import useCheckAccess from 'hooks/useCheckAccess';
import React from 'react';
import { Create, SimpleForm, TextInput } from 'react-admin';

const BillingGroupManagementCompaniesCreate = () => {
  const checkAccess = useCheckAccess();

  return (
    <Create redirect="show">
      <SimpleForm>
        {checkAccess('create', 'BillingGroupManagementCompany', 'name') && (
          <TextInput source="name" />
        )}
      </SimpleForm>
    </Create>
  );
};

export default BillingGroupManagementCompaniesCreate;
